import { useState, useEffect } from "react";
import {
  Page,
  Navbar,
  BtnBlock,
  DialogBox,
  BtnSmall,
  BtnSmallDisabled,
  PopUp,
} from "../../components";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import Member from "../../assets/images/member.png";
import Loader from "../../components/loader";
import {
  upadteDepartmenName,
  allDepartements,
  getADepartment,
  searchUser,
  getuserofDepartment,
  addUserinDep,
} from "../../assets/Js/script";
import * as ROUTES from "../../constant/routes";
import { ToastContainer, toast } from "react-toastify";

import HeaderIcon from "../../components/Header_icon";

export default function Department() {
  const notify = (message) => toast(message);

  const [modals, setModals] = useState({
    addNew: false,
    uploadByBook: false,
    editDepartmentName: false,
    newDepartmentCreated: false,
  });
  const { id, orgId } = useParams();
  const navigate = useNavigate();
  const [uploadByBook, setUploadByBook] = useState(true);
  const [editDepartmment, setEditDepartmment] = useState("");
  const [deptData, setDepData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [getAllDep, setGetAllDep] = useState([]);
  const [selectedusers, setSelectedUser] = useState([]);
  const [userofDep, setUserofDep] = useState(null);
  const [isLoader, setIsLoader] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);

  const Params = useParams();

  console.log(deptData, 'deptData');

  //////////////////////// api ////////////// api //////////
  useEffect(() => {
    async function department() {
      const { response, error } = await getADepartment(orgId);
      if (response.status === "success") {
        // console.log(response)
        setDepData({ ...response.data.department });
        setEditDepartmment(response.data.department.departmentName);
      }
    }

    department();

    async function getAllDep() {
      const { response, error } = await allDepartements();
      if (response.status === "success") {
        setGetAllDep([...response.data.departments]);
      }
    }

    async function getuserOfDep() {
      setIsLoader(true);
      const { response, error } = await getuserofDepartment(orgId);
      if (response.status === "success") {
        setUserofDep({ ...response.data.department });
        setIsLoader(false);
      }
    }
    getuserOfDep();
  }, [modals.newDepartmentCreated, modals.editDepartmentName]);
  
  useEffect(() => {
    async function search() {
      setSearchLoader(true);
      if (searchText.length > 0) {
        const { response, error } = await searchUser(searchText,deptData.id);
        if (response.status === "success") {
          setSearchLoader(false);
          console.log(response.data.organisations,'kljsdfkjlksdfj')
          setSearchData([...response.data.organisations]);
        }
      } else {
        setSearchLoader(false);
        setSearchData([]);
      }
    }
    search();
  }, [searchText]);
  useEffect(() => {}, [searchData]);

  async function addNewUsers() {
    const { response, error } = await addUserinDep(deptData?.id, selectedusers);

    if (response.status === "success") {
      setModals((prevState) => ({
        ...prevState,
        addNew: false,
        newDepartmentCreated: true,
      }));
      searchText("");
      setSearchData([])
    } else {
      notify(response?.message ? response?.message : "Something went wrong");
    }
  }

  async function updatedepName() {
    const { response, error } = await upadteDepartmenName(
      editDepartmment,
      orgId
    );
    setIsLoader(true);

    if (response.status === "success") {
      setModals((prev) => ({ ...prev, editDepartmentName: false }));
      setIsLoader(false);
    } else {
      setIsLoader(false);
      notify(response?.message ? response?.message : "Something went wrong");
    }
  }

  //////////////////////// api ///////////// api /////////////

  function handleUploadType({ target }) {
    setUploadByBook(target.name === "radio-1" ? true : false);
  }
  function selectUser(e, id, checked) {
    setSearchData(
      searchData.map((user) =>
        user.id === id ? { ...user, isChecked: !checked } : user
      )
    );
    selectedusers.push(id);
  }
  useEffect(() => {
    document.body.style.position = "relative";
  }, []);

  // console.log(selectedusers, "fdh");

  // function validatedep() {
  //   if(editDepartmment) {
  //     for(let i = 0; i < getAllDep.length; i++) {
  //       if(editDepartmment.toLowerCase() === getAllDep[i].departmentName.toLowerCase()) {
  //         return true;
  //       }
  //     }
  //   }

  //   return false;

  // }

  return (
    <Page active="wallet">
      <Navbar />
      {isLoader ? (
        <Loader show={isLoader} />
      ) : (
        <>
          <div className="hidden lg:flex items-center justify-between">
            <div className="flex flex-col justify-between">
              <h1 className="text-h1 relative text-heading text-left font-semibold">
                <button
                  onClick={() => navigate(-1)}
                  className="absolute -left-8 top-[6px]"
                >
                  <svg
                    width="29"
                    height="27"
                    viewBox="0 0 29 27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.7118 21.3749C16.5313 21.3755 16.353 21.3384 16.1899 21.2664C16.0268 21.1944 15.8831 21.0892 15.7693 20.9587L9.93308 14.2087C9.75536 14.0074 9.6582 13.7549 9.6582 13.4943C9.6582 13.2337 9.75536 12.9812 9.93308 12.7799L15.9748 6.02994C16.1799 5.8002 16.4746 5.65572 16.7941 5.6283C17.1136 5.60087 17.4317 5.69274 17.6785 5.88369C17.9253 6.07465 18.0804 6.34905 18.1099 6.64653C18.1394 6.94401 18.0407 7.2402 17.8356 7.46994L12.4343 13.4999L17.6543 19.5299C17.8021 19.6951 17.896 19.8962 17.9248 20.1094C17.9537 20.3226 17.9163 20.5391 17.8172 20.7332C17.718 20.9273 17.5612 21.0909 17.3653 21.2046C17.1694 21.3183 16.9427 21.3775 16.7118 21.3749Z"
                      fill="#494949"
                    />
                  </svg>
                </button>{" "}
                Departments:{" "}
                <span className="capitalize ">{deptData?.departmentName}</span>
              </h1>
              {/* <p className="text-secondary-light font-semibold text-montserrat text-h5 ">
            View &#38; manage users in this Department
          </p> */}
            </div>
            <button
              onClick={() =>
                setModals((prevState) => ({ ...prevState, addNew: true }))
              }
              className=" outline-0 border-0 underline text-tertiary-dark text text-h5 text-montserrat font-semibold"
            >
              Add User to Department
            </button>
          </div>
          <HeaderIcon heading={"Departments"} />

          <p className="lg:hidden leading-[19.44px] text-secondary-light font-bold mt-5">
            Lorem ipsum dolor sit amet, consectetu
          </p>
          <div className="flex lg:px-0 my-8 flex-col">
            <h3 className="flex items-center text-montserrat capitalize text-h4 font-semibold text-secondary-dark lg:text-heading">
              {deptData?.departmentName}
              <button
                onClick={() =>
                  setModals((prevState) => ({
                    ...prevState,
                    editDepartmentName: true,
                  }))
                }
                className="outline-0 border-0 ml-2"
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.9375 3.71875L13.2812 1.0625L2.65625 11.6875L1.59375 15.4062L5.3125 14.3438L15.9375 3.71875ZM11.1562 3.1875L13.8125 5.84375L11.1562 3.1875ZM2.65625 11.6875L5.3125 14.3438L2.65625 11.6875Z"
                    stroke="#B3B3B3"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </h3>
            <p className="font-semibold text-secondary-dark text-[17px] text-montserrat mt-2">
              View &#38; Manage Users in this Department
            </p>
          </div>

          <div className="w-full lg:px-0 items-center flex flex-wrap gap-x-16 mb-6 gap-y-8 gap-6">
            {userofDep?.Ousers?.map((card, index) => (
              <div
                key={card}
                onClick={() => navigate(`/users/order-history=${card.id}`)}
                className="flex flex-col lg:flex-row  max-w-[330px] lg:max-w-none min-w-[305px] w-[100%] relative justify-center lg:justify-start lg:gap-2 lg:items-center border-1 lg:mb-2 lg:ml-2 border-solid border-primary-dark-20 lg:w-card h-[168px]"
              >
                <div
                  className={`w-14 left-2 hidden self-start lg:flex m-2 items-center justify-center h-14 rounded-full ${
                    card.photo == null && "bg-primary-dark"
                  } `}
                >
                  {card.photo ? (
                    <img src={card.photo} alt="img" />
                  ) : (
                    <span
                      className={`text-[25px] uppercase font-bold text-[#fff]`}
                    >
                      {card.fullName[0]}
                    </span>
                  )}
                </div>
                <div className="flex flex-col">
                  <div className="ml-[70px] lg:ml-0 flex items-center">
                    <h4 className="mb-2 capitalize lg:mb-3 flex items-center text-secondary-dark font-semibold text-h5 mr-4">
                      {card.fullName}
                      <button
                        className={`${
                          card.status === "pending"
                            ? "bg-[#F4D429] "
                            : card.status === "active"
                            ? "bg-primary-dark"
                            : card.status === "disable"
                            ? "bg-[#AEAEAE]"
                            : "bg-[#fff]"
                        } ml-4 py-[2px] px-[34px] text-montserrat font-semibold capitalize text-tablet-p1 text-primary-white `}
                      >
                        {card.status}
                      </button>
                    </h4>
                    {modals.makePrimary && (
                      <p className="flex items-center text-p1 font-semibold text-tertiary-dark ">
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0 8.5C0 6.24566 0.895533 4.08365 2.48959 2.48959C4.08365 0.895533 6.24566 0 8.5 0C10.7543 0 12.9163 0.895533 14.5104 2.48959C16.1045 4.08365 17 6.24566 17 8.5C17 10.7543 16.1045 12.9163 14.5104 14.5104C12.9163 16.1045 10.7543 17 8.5 17C6.24566 17 4.08365 16.1045 2.48959 14.5104C0.895533 12.9163 0 10.7543 0 8.5H0ZM8.01493 12.138L12.9087 6.02027L12.0247 5.31307L7.85173 10.5275L4.896 8.0648L4.17067 8.9352L8.01493 12.1391V12.138Z"
                            fill="#FFD600"
                          />
                        </svg>
                        Primary Contact
                      </p>
                    )}
                  </div>
                  <div className="hidden lg:flex items-center mt-4 lg:mt-2">
                    <p className="text-p1 text-secondary-light mr-11">
                      Dept. name:
                    </p>
                    <p className="text-p1 font-semibold w-[160px] capitalize overflow-hidden whitespace-nowrap text-ellipsis text-secondary-dark">
                        {userofDep['Department Name']}
                        {/* {card.Departments?.length === 0 && "Not in any Department "} */}
                      </p>
                  </div>
                  <div className="hidden lg:flex items-center">
                    <p className="text-p1 text-secondary-light mr-6">
                      E-mail address:
                    </p>
                    <p className="text-p1 font-semibold text-secondary-dark ">
                      {card.email}
                    </p>
                  </div>
                  <div className="hidden lg:flex items-center ">
                    <p className="text-p1 text-secondary-light mr-6">
                      Phone number:
                    </p>
                    <p className="text-p1 font-semibold text-secondary-dark">
                      +91 {card.mobile}
                    </p>
                  </div>
                </div>
                {/* this div is for mobile version \|/ */}
                <div className="ml-[10px] flex lg:hidden flex-col">
                  <div className="flex items-center mt-4 lg:mt-2">
                    <p className="text-p1 text-secondary-light mr-11">
                      Dept. name:
                    </p>
                    <p className="text-p1 capitalize font-semibold text-secondary-dark">
                    {userofDep['Department Name']}

                    </p>
                  </div>
                  <div className="flex items-center">
                    <p className="text-p1 text-secondary-light mr-6">
                      E-mail address:
                    </p>
                    <p className="text-p1 font-semibold text-secondary-dark">
                      {card.email}
                    </p>
                  </div>
                  <div className="flex items-center ">
                    <p className="text-p1 text-secondary-light mr-6">
                      Phone number:
                    </p>
                    <p className="text-p1 font-semibold text-secondary-dark">
                      +91 {card.mobile}
                    </p>
                  </div>
                </div>
                {/* <button
              onClick={(e) => {
                setModals((prevState) => ({ ...prevState, deleteUser: true }));
              }}
              className="absolute top-4 lg:top-6 right-3 lg:right-4"
            >
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.61927 9.65676C9.38022 9.87286 9.056 9.99427 8.71794 9.99427C8.37988 9.99427 8.05566 9.87286 7.8166 9.65676L5.00053 6.74689L2.18446 9.6558C2.06645 9.76424 1.92585 9.85049 1.77078 9.90956C1.61572 9.96864 1.44925 9.99937 1.28097 9.99999C1.1127 10.0006 0.945962 9.9711 0.790368 9.91317C0.634774 9.85524 0.493406 9.77003 0.374419 9.66246C0.255433 9.55489 0.161182 9.42709 0.097104 9.28642C0.0330256 9.14575 0.000387576 8.99501 0.00107276 8.84288C0.00175794 8.69075 0.0357526 8.54026 0.101096 8.40007C0.166439 8.25988 0.261838 8.13277 0.38179 8.02608L3.31153 5.00096L0.380728 1.97392C0.260776 1.86723 0.165377 1.74012 0.100034 1.59993C0.0346904 1.45974 0.000695752 1.30925 1.05685e-05 1.15712C-0.000674615 1.00499 0.0319635 0.854247 0.0960419 0.71358C0.16012 0.572914 0.254371 0.445109 0.373357 0.337538C0.492344 0.229967 0.633711 0.144758 0.789306 0.0868277C0.9449 0.0288969 1.11164 -0.000609893 1.27991 9.55452e-06C1.44818 0.000629002 1.61465 0.0313623 1.76972 0.0904366C1.92479 0.149511 2.06538 0.235758 2.1834 0.344201L5.00053 3.25504L7.8166 0.344201C7.93462 0.235758 8.07521 0.149511 8.23028 0.0904366C8.38535 0.0313623 8.55182 0.000629002 8.72009 9.55452e-06C8.88836 -0.000609893 9.0551 0.0288969 9.21069 0.0868277C9.36629 0.144758 9.50766 0.229967 9.62664 0.337538C9.74563 0.445109 9.83988 0.572914 9.90396 0.71358C9.96804 0.854247 10.0007 1.00499 9.99999 1.15712C9.9993 1.30925 9.96531 1.45974 9.89997 1.59993C9.83462 1.74012 9.73922 1.86723 9.61927 1.97392L6.68954 5.00096L9.61927 8.02608C9.73779 8.13311 9.83181 8.26021 9.89596 8.40011C9.96011 8.54001 9.99313 8.68997 9.99313 8.84142C9.99313 8.99287 9.96011 9.14283 9.89596 9.28273C9.83181 9.42263 9.73779 9.54973 9.61927 9.65676Z"
                  fill="black"
                  fill-opacity="0.35"
                />
              </svg>
            </button> */}

                <div
                  className={`w-14 lg:hidden absolute top-2  left-2 flex items-center justify-center h-14 rounded-full ${
                    card.photo == null && "bg-primary-dark"
                  } `}
                >
                  {card.photo ? (
                    <img src={card.photo} alt="img" />
                  ) : (
                    <span
                      className={`text-[25px] uppercase font-bold text-[#fff]`}
                    >
                      {card.fullName[0]}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="lg:hidden mt-8 mb-20 px-4 text-center">
            <button
              onClick={() =>
                setModals((prevState) => ({ ...prevState, addNew: true }))
              }
              className="w-full h-[54px] bg-primary-dark text-primary-white text text-h5 text-montserrat font-semibold"
            >
              Add a new user
            </button>
          </div>
          {modals.addNew && (
            <div className="fixed lg:absolute flex lg:justify-center lg:items-center top-0 left-0 w-full h-screen  bg-primary-light overflow-hidden">
              <div className="h-[90%] overflow-y-scroll  lg:overflow-y-auto pt-12 pb-28 lg:pt-8 lg:pb-8 px-6 lg:px-8 bg-primary-white flex flex-col relative w-full lg:w-pop-up min-h-pop-up lg:p-8">
                <div className="flex items-center mb-4 lg:justify-start justify-between">
                  <h4 className="text-h4 flex items-center text-tertiary-dark font-bold">
                    <button className="mr-2">
                      <svg
                        width="12"
                        height="20"
                        viewBox="0 0 12 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.0491 2.5473L9.4174 0.924805L0.351562 9.9998L9.42656 19.0748L11.0491 17.4523L3.59656 9.9998L11.0491 2.5473Z"
                          fill="#702963"
                        />
                      </svg>
                    </button>
                    Add a User to this Department
                  </h4>
                  <div className="lg:hidden flex items-center">
                    <button className="mr-5">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M25.25 25.25L19.5104 19.5104M22.6111 12.0556C22.6111 17.8852 17.8852 22.6111 12.0556 22.6111C6.22588 22.6111 1.5 17.8852 1.5 12.0556C1.5 6.22588 6.22588 1.5 12.0556 1.5C17.8852 1.5 22.6111 6.22588 22.6111 12.0556Z"
                          stroke="#702963"
                          stroke-width="2.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                    <button>
                      <svg
                        width="28"
                        height="24"
                        viewBox="0 0 28 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M25.715 10.285H25.742C26.207 10.285 26.627 10.477 26.927 10.787C27.237 11.088 27.429 11.508 27.429 11.973V12.001V12.027C27.429 12.492 27.237 12.912 26.927 13.212C26.626 13.522 26.206 13.714 25.741 13.714H25.713H25.513L23.972 22.583C23.9068 22.9816 23.698 23.3426 23.385 23.598L23.382 23.6C23.092 23.849 22.712 24.001 22.297 24.001H5.13C4.715 24.001 4.335 23.849 4.043 23.598L4.045 23.6C3.73304 23.3466 3.52402 22.9883 3.457 22.592L3.456 22.582L1.915 13.713H1.687C1.222 13.713 0.802001 13.521 0.502001 13.211C0.342948 13.0572 0.216523 12.8729 0.130273 12.6691C0.044023 12.4653 -0.000282597 12.2463 1.35628e-06 12.025V11.997V11.971C1.35628e-06 11.506 0.192001 11.086 0.502001 10.786C0.803001 10.476 1.223 10.284 1.688 10.284H1.716H1.715L25.715 10.285ZM6.492 20.999C6.6042 20.9913 6.71365 20.9608 6.81357 20.9092C6.9135 20.8576 7.00179 20.7861 7.073 20.699L7.074 20.698C7.14997 20.6136 7.20767 20.5145 7.24346 20.4068C7.27926 20.299 7.29238 20.185 7.282 20.072V20.075L6.853 14.503C6.84535 14.3908 6.81478 14.2814 6.76318 14.1814C6.71158 14.0815 6.64005 13.9932 6.553 13.922L6.552 13.921C6.46765 13.845 6.36848 13.7873 6.26075 13.7515C6.15302 13.7157 6.03905 13.7026 5.926 13.713H5.929C5.8168 13.7207 5.70736 13.7512 5.60743 13.8028C5.5075 13.8544 5.41921 13.926 5.348 14.013L5.347 14.014C5.27103 14.0984 5.21333 14.1975 5.17754 14.3052C5.14174 14.413 5.12862 14.527 5.139 14.64V14.637L5.568 20.209C5.58227 20.425 5.68064 20.6267 5.842 20.771L5.843 20.772C5.99738 20.9185 6.20215 21.0002 6.415 21H6.426H6.425L6.492 20.999ZM11.997 20.143V14.571V14.563C11.9973 14.4519 11.975 14.3419 11.9313 14.2398C11.8876 14.1377 11.8235 14.0455 11.743 13.969C11.6662 13.8885 11.5739 13.8245 11.4716 13.7808C11.3693 13.7372 11.2592 13.7148 11.148 13.715H11.132C11.0209 13.7147 10.9109 13.737 10.8088 13.7807C10.7067 13.8244 10.6145 13.8885 10.538 13.969C10.4575 14.0458 10.3935 14.1381 10.3498 14.2404C10.3062 14.3427 10.2838 14.4528 10.284 14.564V20.152C10.284 20.386 10.381 20.597 10.538 20.746C10.6148 20.8265 10.7071 20.8905 10.8094 20.9342C10.9117 20.9778 11.0218 21.0002 11.133 21H11.149C11.2601 21.0003 11.3701 20.978 11.4722 20.9343C11.5743 20.8906 11.6665 20.8265 11.743 20.746C11.8246 20.6692 11.8895 20.5766 11.9339 20.4737C11.9783 20.3709 12.0011 20.26 12.001 20.148V20.142L11.997 20.143ZM17.14 20.143V14.571V14.563C17.1403 14.4519 17.118 14.3419 17.0743 14.2398C17.0306 14.1377 16.9665 14.0455 16.886 13.969C16.8092 13.8885 16.7169 13.8245 16.6146 13.7808C16.5123 13.7372 16.4022 13.7148 16.291 13.715H16.275C16.1639 13.7147 16.0539 13.737 15.9518 13.7807C15.8497 13.8244 15.7575 13.8885 15.681 13.969C15.6005 14.0458 15.5365 14.1381 15.4928 14.2404C15.4492 14.3427 15.4268 14.4528 15.427 14.564V20.152C15.427 20.386 15.524 20.597 15.681 20.746C15.7578 20.8265 15.8501 20.8905 15.9524 20.9342C16.0547 20.9778 16.1648 21.0002 16.276 21H16.292C16.4031 21.0003 16.5131 20.978 16.6152 20.9343C16.7173 20.8906 16.8095 20.8265 16.886 20.746C16.9676 20.6692 17.0325 20.5766 17.0769 20.4737C17.1213 20.3709 17.1441 20.26 17.144 20.148V20.142L17.14 20.143ZM21.854 20.209L22.283 14.637C22.2927 14.5243 22.2792 14.4108 22.2435 14.3035C22.2077 14.1962 22.1504 14.0974 22.075 14.013L22.076 14.014C22.005 13.9268 21.9169 13.8551 21.8172 13.8032C21.7174 13.7512 21.6081 13.7202 21.496 13.712H21.493C21.3803 13.7023 21.2668 13.7158 21.1595 13.7515C21.0522 13.7873 20.9534 13.8446 20.869 13.92L20.87 13.919C20.7828 13.99 20.7111 14.0781 20.6592 14.1778C20.6072 14.2776 20.5762 14.3869 20.568 14.499V14.502L20.139 20.074C20.1293 20.1867 20.1428 20.3002 20.1786 20.4075C20.2143 20.5148 20.2716 20.6137 20.347 20.698L20.346 20.697C20.417 20.7842 20.5051 20.8559 20.6048 20.9078C20.7046 20.9598 20.8139 20.9908 20.926 20.999H21.006C21.2191 20.999 21.4241 20.9174 21.579 20.771C21.7424 20.6269 21.8426 20.4243 21.858 20.207V20.204L21.854 20.209ZM6.376 3.909L5.131 9.427H3.363L4.715 3.521C4.878 2.736 5.305 2.071 5.897 1.606L5.904 1.601C6.49976 1.11787 7.24397 0.85509 8.011 0.857001H8.049H8.047H10.283V0.849001C10.283 0.615001 10.38 0.404001 10.537 0.255001C10.6138 0.174269 10.7063 0.110026 10.8088 0.0661855C10.9112 0.0223455 11.0216 -0.000173409 11.133 1.00545e-06H16.295C16.529 1.00545e-06 16.74 0.097001 16.889 0.254001C16.9695 0.330769 17.0335 0.423105 17.0772 0.525393C17.1208 0.627681 17.1432 0.737783 17.143 0.849001V0.857001H19.416C20.217 0.857001 20.952 1.137 21.528 1.605L21.522 1.6C22.1286 2.07342 22.5483 2.74605 22.707 3.499L22.711 3.52L24.063 9.426H22.295L21.05 3.908C20.9595 3.52933 20.7465 3.19115 20.444 2.946L20.441 2.943C20.1467 2.69994 19.7767 2.56731 19.395 2.568H17.14V2.576C17.1403 2.68709 17.118 2.79707 17.0743 2.89921C17.0306 3.00135 16.9665 3.09349 16.886 3.17C16.8092 3.25048 16.7169 3.31449 16.6146 3.35816C16.5123 3.40183 16.4022 3.42423 16.291 3.424H11.133C11.0219 3.42432 10.9119 3.40196 10.8098 3.35829C10.7077 3.31461 10.6155 3.25054 10.539 3.17C10.4585 3.09323 10.3945 3.0009 10.3508 2.89861C10.3072 2.79632 10.2848 2.68622 10.285 2.575V2.567H8.03C7.64739 2.56657 7.27666 2.69993 6.982 2.944L6.985 2.942C6.68473 3.18519 6.47283 3.52043 6.382 3.896L6.38 3.908L6.376 3.909Z"
                          fill="#702963"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <p className="text-secondary-light w-11/12">
                  Select one or multiple users from the list to add them to this
                  department
                </p>

                <div>
                  {/* <p className="hidden lg:block text-[15px] text-heading-false font-semibold text-montserrat mt-[14px]">
                Add users
              </p> */}
                  <form className="my-4 p-3 h-12 border-1 border-solid border-[#eee] flex ">
                    <button className="pr-2">
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 17.5L13.1333 13.6333M15.2222 8.61111C15.2222 12.5385 12.0385 15.7222 8.11111 15.7222C4.18375 15.7222 1 12.5385 1 8.61111C1 4.68375 4.18375 1.5 8.11111 1.5C12.0385 1.5 15.2222 4.68375 15.2222 8.61111Z"
                          stroke="#702963"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                    <input
                      type="text"
                      placeholder="Enter Name, Email or Designation"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      className="w-[calc(100%-36px)] capitalize font-semibold outline-0 border-0 text h-full"
                    />
                  </form>
                  {!searchLoader ? (
                    searchData?.length > 0 ? (
                      <div>
                        {searchData.map((item, index) => {
                          return (
                            <div
                              key={index}
                              onClick={(e) => {
                                e.stopPropagation();
                                selectUser(e, item.id, item.isChecked);
                              }}
                              className="flex items-center w-full px-3 py-4 h-[82px] bg-[rgba(203,155,194,0.13)] border-1 border-solid border-[#eee] mb-3"
                            >
                              <input
                                type="checkbox"
                                name={item.id}
                                checked={item?.isChecked}
                                className="hidden"
                                id="checkbox"
                                disabled
                              />
                              <label
                                htmlFor="checkbox"
                                className={`${
                                  item?.isChecked && "bg-[#702963]"
                                } flex justify-center items-center w-4 h-4 rounded-full border-1 border-solid border-[rgba(112,41,99,0.24)]`}
                              >
                                {item?.isChecked && (
                                  <svg
                                    width="9"
                                    height="6"
                                    viewBox="0 0 9 6"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M0.187945 2.25361C0.308322 2.14325 0.471567 2.08125 0.641781 2.08125C0.811994 2.08125 0.975239 2.14325 1.09562 2.25361L3.36544 4.3352L7.9038 0.172604C7.96339 0.117909 8.03416 0.0745153 8.11204 0.0448998C8.18993 0.0152844 8.27341 2.73702e-05 8.35773 3.67917e-08C8.44204 -2.72966e-05 8.52554 0.0151756 8.60344 0.0447405C8.68135 0.0743055 8.75215 0.117654 8.81179 0.17231C8.87143 0.226966 8.91875 0.29186 8.95104 0.363287C8.98333 0.434713 8.99997 0.511274 9 0.588597C9.00003 0.665919 8.98345 0.742491 8.95121 0.813938C8.91897 0.885386 8.87171 0.95031 8.81211 1.00501L3.36544 6L0.187945 3.08601C0.0676038 2.97561 0 2.82591 0 2.66981C0 2.51371 0.0676038 2.364 0.187945 2.25361Z"
                                      fill="white"
                                    />
                                  </svg>
                                )}
                              </label>
                              <div className="w-[42px] h-[42px] flex justify-center items-center rounded-full bg-neutral-20 mx-4 bg-secondary-dark">
                                {item.photo === null ? (
                                  <p className="uppercase text-[#fff] text-[23px]">
                                    {item.fullName[0]}
                                  </p>
                                ) : (
                                  <img
                                    src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/books/${item.photo}`}
                                    alt="Cover photo"
                                    className="h-full object-cover w-full"
                                  />
                                )}
                              </div>
                              <div className="flex flex-col justify-between">
                                <h3 className="text-heading-false capitalize font-semibold text-montserrat text-h5">
                                  {item.fullName}
                                </h3>
                                <p className="font-[500] text-secondary-light capitalize">
                                  {item.designation}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="flex justify-center items-center flex-col  " >
                      <span className="w-[120px] h-[120px] rounded-full bg-[rgba(210,209,209,0.25)] flex justify-center items-center">
                        <svg
                          width="67"
                          height="67"
                          viewBox="0 0 67 67"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M65.125 64.3763L50.3586 49.9581L65.125 64.3763ZM58.5416 30.6888C58.5416 37.9215 55.5938 44.8579 50.3467 49.9722C45.0996 55.0865 37.983 57.9596 30.5625 57.9596C23.1419 57.9596 16.0253 55.0865 10.7782 49.9722C5.53111 44.8579 2.58331 37.9215 2.58331 30.6888C2.58331 23.4561 5.53111 16.5197 10.7782 11.4054C16.0253 6.29114 23.1419 3.41797 30.5625 3.41797C37.983 3.41797 45.0996 6.29114 50.3467 11.4054C55.5938 16.5197 58.5416 23.4561 58.5416 30.6888V30.6888Z"
                            stroke="#B6B6B6"
                            stroke-width="5"
                            stroke-linecap="round"
                          />
                        </svg>
                      </span>
                       {searchText !== "" ?(<p className="mt-4 mb-1 text-cabin font-medium text-[18px] leading-[24px] text-[rgba(0,0,0,0.56)] text-center">
                        Sorry couldn't find any users
                      </p>)
                      :
                      (<p className="mt-4 mb-1 text-cabin font-medium text-[18px] leading-[24px] text-[rgba(0,0,0,0.56)] text-center">
                        Please enter user Name
                      </p>)}
                      </div>
                    )
                  ) : (
                    <div className="flex justify-center items-center  h-[164px] flex-col ">
                      <svg
                        className="animate-spin ml-1 mr-3 h-12 w-12 text-[#702963]"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          class="opacity-20"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          stroke-width="4"
                        ></circle>
                        <path
                          class="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      <p className="text-secondary-light text-p1">
                        Searching....
                      </p>

                      {/* <span className="w-[120px] h-[120px] rounded-full bg-[rgba(210,209,209,0.25)] flex justify-center items-center">
                        <svg
                          width="67"
                          height="67"
                          viewBox="0 0 67 67"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M65.125 64.3763L50.3586 49.9581L65.125 64.3763ZM58.5416 30.6888C58.5416 37.9215 55.5938 44.8579 50.3467 49.9722C45.0996 55.0865 37.983 57.9596 30.5625 57.9596C23.1419 57.9596 16.0253 55.0865 10.7782 49.9722C5.53111 44.8579 2.58331 37.9215 2.58331 30.6888C2.58331 23.4561 5.53111 16.5197 10.7782 11.4054C16.0253 6.29114 23.1419 3.41797 30.5625 3.41797C37.983 3.41797 45.0996 6.29114 50.3467 11.4054C55.5938 16.5197 58.5416 23.4561 58.5416 30.6888V30.6888Z"
                            stroke="#B6B6B6"
                            stroke-width="5"
                            stroke-linecap="round"
                          />
                        </svg>
                      </span> */}
                      {/* {searchText !== "" ? */}
                      {/* (<p className="mt-4 mb-1 text-cabin font-medium text-[18px] leading-[24px] text-[rgba(0,0,0,0.56)] text-center">
                        Sorry couldn't find any users
                      </p>)
                      :
                      (<p className="mt-4 mb-1 text-cabin font-medium text-[18px] leading-[24px] text-[rgba(0,0,0,0.56)] text-center">
                        Please enter user Name
                      </p>)} */}
                    </div>
                  )}
                  <div className="flex justify-end items-center mt-6">
                    <div className="hidden lg:block">
                      <BtnSmall onClick={addNewUsers}>Add users</BtnSmall>
                    </div>
                    <div className="lg:hidden">
                      <button
                        onClick={addNewUsers}
                        className="disabled:opacity-[0.5] bg-primary-dark text-primary-white w-[110px] h-[48px]"
                      >
                        Add Users
                      </button>
                    </div>
                  </div>
                </div>

                <button
                  onClick={() => {
                    setModals((prevState) => ({ ...prevState, addNew: false }));
                    setSearchText("");
                  }}
                  className="hidden lg:block absolute top-8 right-8"
                >
                  <svg
                    width="12"
                    height="14"
                    viewBox="0 0 12 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                      fill="black"
                      fillOpacity="0.53"
                    />
                  </svg>
                </button>
              </div>
            </div>
          )}
          <DialogBox show={modals.newDepartmentCreated}>
            <div className="bg-primary-white flex flex-col justify-between relative w-full h-[463px] lg:w-pop-up lg:h-pop-up p-8">
              <h4 className="text-h4 text-tertiary-dark font-bold">
                A new user has been added
              </h4>
              <h5 className="text-heading font-bold">
                Human resource Department has been added
              </h5>
              <p className="text-secondary-light">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget
                utvest-ibulum bibendum egestas. Enim mi arcu convallis enim
                purus interdum. Ut neque at adipiscing torotr facilisis asgittis
                levero. Ac bibendum vel blandit.
              </p>
              <div className="text-center lg:text-right mb-12 lg:mb-0">
                <button
                  onClick={() => {
                    setModals((prevState) => ({
                      ...prevState,
                      newDepartmentCreated: false,
                    }));
                    navigate(ROUTES.DEPARTMENTS);
                  }}
                  className="py-4 px-3 min-w-full  lg:min-w-[150px]  h-[56px] bg-primary-dark text-primary-white text-mobile-h5 lg:text-h5"
                >
                  Back to Department
                </button>
              </div>
              <button
                onClick={() =>
                  setModals((prevState) => ({
                    ...prevState,
                    newDepartmentCreated: false,
                  }))
                }
                className="absolute top-8 right-8"
              >
                <svg
                  width="12"
                  height="14"
                  viewBox="0 0 12 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                    fill="black"
                    fillOpacity="0.53"
                  />
                </svg>
              </button>
            </div>
          </DialogBox>

          <DialogBox show={modals.editDepartmentName}>
            <div className="bg-primary-white flex flex-col justify-between relative w-pop-up h-fit max-h-[450px] lg:h-[323px] p-8">
              <h4 className="text-h4 text-tertiary-dark font-bold mt-3 lg:mt-0">
                Edit Department Details
              </h4>

              {userofDep?.Ousers?.length == 0 && (
                <p className="text-secondary-light">
                  No Users added to the Department
                </p>
              )}

              <div className="flex gap-2 flex-col">
                <p className="text-secondary-dark font-semibold text-montserrat">
                  Department Name
                </p>
                <input
                  type="text"
                  required
                  value={editDepartmment}
                  onChange={(e) => setEditDepartmment(e.target.value)}
                  placeholder="Enter department name"
                  className="border-1 border-solid capitalize border-[#eeeeee] py-[14px] h-[48px] w-[234px] lg:w-[181px] px-2 font-semibold text-heading"
                />
              </div>
              {/* <p className="mb-4 md:mb-6 mt-[-16px] md:mt-[0px] text-[13px] text-[red]">
                  {validatedep() && "Department Name already exist!"}
            </p> */}

              <div className="hidden lg:flex justify-end">
                <BtnSmall onClick={() => updatedepName()}>Save</BtnSmall>
              </div>
              <div className="lg:hidden flex justify-end mb-12">
                <BtnBlock>Save</BtnBlock>
              </div>
              <button
                onClick={() =>
                  setModals((prevState) => ({
                    ...prevState,
                    editDepartmentName: false,
                  }))
                }
                className="absolute top-3 right-3 lg:top-6 lg:right-7"
              >
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.6529 19.3037C18.3603 19.5963 17.9636 19.7606 17.5498 19.7606C17.1361 19.7606 16.7393 19.5963 16.4468 19.3037L13.0005 15.3647L9.55419 19.3024C9.40977 19.4492 9.23771 19.566 9.04794 19.6459C8.85817 19.7259 8.65444 19.7675 8.44851 19.7683C8.24258 19.7692 8.03852 19.7292 7.84811 19.6508C7.65769 19.5724 7.48469 19.4571 7.33907 19.3114C7.19346 19.1658 7.07811 18.9928 6.9997 18.8024C6.92128 18.612 6.88133 18.4079 6.88217 18.202C6.88301 17.9961 6.92461 17.7923 7.00458 17.6026C7.08455 17.4128 7.2013 17.2407 7.34809 17.0963L10.9335 13.0013L7.34679 8.90372C7.2 8.7593 7.08325 8.58724 7.00328 8.39747C6.92331 8.2077 6.88171 8.00397 6.88087 7.79804C6.88003 7.59211 6.91998 7.38805 6.9984 7.19764C7.07681 7.00722 7.19216 6.83422 7.33777 6.6886C7.48339 6.54299 7.65639 6.42764 7.84681 6.34923C8.03722 6.27081 8.24128 6.23086 8.44721 6.2317C8.65314 6.23254 8.85687 6.27414 9.04664 6.35411C9.23641 6.43408 9.40847 6.55083 9.55289 6.69762L13.0005 10.6379L16.4468 6.69762C16.5912 6.55083 16.7633 6.43408 16.9531 6.35411C17.1428 6.27414 17.3465 6.23254 17.5525 6.2317C17.7584 6.23086 17.9625 6.27081 18.1529 6.34923C18.3433 6.42764 18.5163 6.54299 18.6619 6.6886C18.8075 6.83422 18.9229 7.00722 19.0013 7.19764C19.0797 7.38805 19.1197 7.59211 19.1188 7.79804C19.118 8.00397 19.0764 8.2077 18.9964 8.39747C18.9164 8.58724 18.7997 8.7593 18.6529 8.90372L15.0675 13.0013L18.6529 17.0963C18.7979 17.2412 18.913 17.4133 18.9915 17.6026C19.07 17.792 19.1104 17.995 19.1104 18.2C19.1104 18.405 19.07 18.608 18.9915 18.7974C18.913 18.9868 18.7979 19.1588 18.6529 19.3037Z"
                    fill="black"
                    fill-opacity="0.53"
                  />
                </svg>
              </button>
            </div>
          </DialogBox>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            closeOnClick
            pauseOnFocusLoss
            pauseOnHover
          />
        </>
      )}
    </Page>
  );
}
